import { Switch as Root } from '@/design-system/switch';
import { Translation } from '@/hoslog-intl';
import * as React from 'react';
import { useController } from 'react-hook-form';
import { useFormField } from '.';
import { UseFormFieldProps } from './type';

interface Props extends UseFormFieldProps, React.ComponentProps<typeof Root> {
  name: string;
}

export const SwitchInput = ({ ...props }: Props) => {
  const { childProps } = useFormField(props);

  const { name } = props;

  const { field } = useController({ name });

  return (
    <div className="flex items-center gap-3">
      <Root
        checked={Boolean(field.value)}
        onCheckedChange={field.onChange}
        defaultChecked={field.value as boolean}
        {...childProps}
      />
      <span className="text-body font-medium">
        <Translation id={props.label || ''} />
      </span>
    </div>
  );
};
